import curd from '../curd'

const BASE_PATH = '/device'

export default curd(BASE_PATH, {
  syncCloud: () => ({
    url: `${BASE_PATH}/cloud/information`,
    method: 'GET'
  }),
  getSiteState: query => ({
    url: `${BASE_PATH}/online/condition`,
    method: 'POST',
    data: query
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/Device.js